import { createComponent } from '@mtfe/sweet';
import { common } from '@mtfe/sweet-utils';
import tpl from './dom.html';
import style from './style.less';
import OtherCouponModal from './OtherCouponModal/script';
import componentUtils from '../../../utils/index';
const { isFunction } = common;
const { Describe } = componentUtils;
// 其他优惠点击上报
const OTHER = 'waimai_3h6wpb4r';
// 独家优惠点击上报
const EXCLUSIVE = 'waimai_49klcmw3';
// 专享商家优惠
const POI_COUPON = 'waimai_26up8w56';
// poiInfoG组件多红包组件ID
const SUB_COMPONENT_MULTIPLE_COUPON_ID = 'waimai_2oehzxqm';

const describeMultipleCoupon = new Describe('MultipleCoupon', SUB_COMPONENT_MULTIPLE_COUPON_ID);
const describeOther = new Describe('Other', OTHER);
const describeExclusive = new Describe('Exclusive', EXCLUSIVE);
const describePoiCoupon = new Describe('PoiCoupon', POI_COUPON);

describeMultipleCoupon.setSubComponent('Other',describeOther)
describeMultipleCoupon.setSubComponent('Exclusive',describeExclusive)
describeMultipleCoupon.setSubComponent('PoiCoupon',describePoiCoupon)

const MultipleCoupon = (props) => {
    const { poiInfo, showCoupon, onCouponBtnClick, onOtherDetailClick } = props;
    const { giftInfo, tspMarketList, totalAmount, tspMarketAmount } = poiInfo;

    const data = {
        poiInfo,
        giftInfo,
        tspMarketList,
        totalAmount,
        tspMarketAmount,
        showCoupon,
        EXCLUSIVE,
        POI_COUPON,
    };
    const events = {
        handleCouponBtnClick: (lxID) => {
            if (isFunction(onCouponBtnClick)) {
                onCouponBtnClick(poiInfo, lxID);
            }
            return false;
        },
        openDetail: () => {
            if (isFunction(onOtherDetailClick)) {
                onOtherDetailClick(OTHER);
            }
            OtherCouponModal({ tspMarketList, tspMarketAmount });
            return false;
        },
        couponEmpty: () => {
            return false;
        },
    };
    const component = createComponent(tpl, { data, style }, events);
    return component;
};
MultipleCoupon.describe = describeMultipleCoupon;
export default MultipleCoupon;
